// extracted by mini-css-extract-plugin
export default {"tableHead":"TableHead_tableHead__g90cm"};